module.exports = __webpack_public_path__ + "static/media/dev.c73bcf04.webp";